/* eslint-disable no-restricted-imports */
import { Card as MuiCard, CardProps as MuiCardProps } from '@material-ui/core';
import { forwardRef } from 'react';

export type CardProps = MuiCardProps;

/**
 * Cards contain content and actions about a single subject.
 *
 * ```js
 * import { Card } from 'ui';
 * ```
 */
export const Card = forwardRef<unknown, CardProps>(({ variant, ...rest }, ref) => {
  return (
    <MuiCard
      {...rest}
      ref={ref}
      variant={variant}
      square={'square' in rest ? rest.square : variant === 'outlined'}
    />
  );
});

export default Card;
